// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"56":"Reports","9909":"CBM"}[chunkId] || chunkId) + "." + {"56":"054dbe2e897304e9dbd9","157":"02e142c71f326175d9ca","5354":"36dfd7ad1877e510a293","8848":"b23028c08123316fd815","9909":"593e8ea49f3b72406bcc"}[chunkId] + ".chunk.css";
};